// FilePreviewEditDialog.jsx
// This component is used to display a dialog for editing file information in the file viewer.

// Copyright HS Analysis GmbH, 2025
// Author: Viktor Eberhardt

// Framework imports
import React from "react";
import PropTypes from "prop-types";

// MUI imports
import { makeStyles } from "@mui/styles";
import Checkbox from "@mui/material/Checkbox";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControlLabel from "@mui/material/FormControlLabel";

// HSA Imports
import { CaseContext } from "../../cases/components/CaseTableDockSideBar";
import { FileViewerContext } from "../FileViewer";
import FilePreviewList from "./FilePreviewList";

const useStyles = makeStyles(() => ({
  contentContainer: {
    display: "grid",
    gridTemplateRows: "auto 1fr",
    overflow: "hidden",
    height: "100%",
  },
  mainContent: {
    overflowY: "auto",
    height: "100%",
  },
}));

const FilePreviewEditDialog = ({ open, onClose }) => {
  const FV =
    React.useContext(FileViewerContext) || React.useContext(CaseContext);
  const classes = useStyles();
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <span>Edit File Information</span>
        <div>
          <FormControlLabel
            control={
              <Checkbox
                checked={FV.showAdditionalName}
                onChange={(e) => FV.setShowAdditionalName(e.target.checked)}
                color="primary"
              />
            }
            label="Show Additional Name"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={FV.showComments}
                onChange={(e) => FV.setShowComments(e.target.checked)}
                color="primary"
              />
            }
            label="Show Comments"
          />
        </div>
      </DialogTitle>
      <DialogContent>
        <div className={classes.contentContainer}>
          <div className={classes.mainContent}>
            <FilePreviewList editMode={true} />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

FilePreviewEditDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default FilePreviewEditDialog;
